// @flow
import React from 'react';
import logo from '../../assets/jovi-logo.svg';
import loading from '../../assets/loading.svg';
import './RegistrationForm.css';
import * as AWS from "aws-sdk";
import { CognitoUserPool, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { Link, Redirect, Route } from 'react-router-dom';
import { Jovi } from '../../../config/DEV.json';
import AvatarInput from '../../components/AvatarInput/AvatarInput';

AWS.config.update({
  region: 'us-east-1',
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: Jovi.AWS.Cognito.IdentityPoolId
  })
});

const poolData = {
  UserPoolId: Jovi.AWS.Cognito.UserPoolId,
  ClientId: Jovi.AWS.Cognito.ClientId
};
const userPool = new CognitoUserPool(poolData);
const s3 = new AWS.S3();

/**
 * 
 * 
 * @param {any} props 
 * @returns 
 */
function FormErrors(props) {
  return props.errors.length > 0 ?
    <div className='FormErrors' id="errors">
      <ul>
        {props.errors.map((error, index) =>
          <li key={index}>{error}</li>
        )}
      </ul>
    </div>
    : null;
}

type RegistrationFormProps = {

};

/**
 * 
 * 
 * @export
 * @class RegistrationForm
 * @extends {React.Component}
 */
export default class RegistrationForm extends React.Component<any, RegistrationFormProps, any> {
  /**
   * Creates an instance of RegistrationForm.
   * @param {any} props 
   * 
   * @memberof RegistrationForm
   */
  constructor(props: RegistrationFormProps) {
    super(props);
    this.state = {
      email: '',
      password: '',
      fullName: '',
      logo: null,
      company: '',
      // phone: '',
      message: 'Alright, let’s get started!',
      logoFilename: 'Company Logo',
      errors: [],
      step: 1,
      buttonText: 'Sign Up',
      // formattedPhone: ''
    }
    this.setMessage = this.setMessage.bind(this);
    this.setErrorMessages = this.setErrorMessages.bind(this);
    this.validateState = this.validateState.bind(this);
    this.onInputChanged = this.onInputChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validateFullName = this.validateFullName.bind(this);
    this.validateCompany = this.validateCompany.bind(this);
    // this.validatePhone = this.validatePhone.bind(this);
  }

  /**
   * 
   * 
   * @param {any} errors 
   * 
   * @memberof RegistrationForm
   */
  setErrorMessages = (errors: string[]): void => {
    this.setState({
      errors
    });
  }

  /**
   * 
   * 
   * @param {any} message 
   * 
   * @memberof RegistrationForm
   */
  setMessage = (message: string): void => {
    this.setState({
      message
    });
  }

  setLogo = (data: string): void => {
    const base64String  = data.replace(/^data:image\/\w+;base64,/, "");
    this.setState({
      logo: new Buffer(base64String, 'base64')
    });
  }

  /**
   * 
   * 
   * @param {any} event 
   * 
   * @memberof RegistrationForm
   */
  onInputChanged = (event: Event & { target: HTMLInputElement }) => {
    const target = event.target;
    let value = null;
    if (target.type === 'checkbox') {
      value = target.checked;
    } else if (target.type === 'file') {
      value = target.files[0];
      this.setState({
        logoFilename: value.name
      });
    } else {
      value = target.value.substr(target.value.lastIndexOf('/') + 1);
    }
    const name = target.name;
    // if (name === 'phone') {
    //   value = value.replace(/\D/g, '');
    // }
    this.setState({
      [name]: value
    });
  }

  /**
   * 
   * 
   * @returns 
   * 
   * @memberof RegistrationForm
   */
  uploadLogo = async () => {
    if (!this.state.logo) {
      console.error('Invalid logo format.');
      return;
    }
    console.log('Uploading photo...');
    const logoKey = `${this.state.email}-avatar.png`;
    await s3.upload({
      Key: logoKey,
      Body: this.state.logo,
      Bucket: 'jovi-avatars',
      ContentType: 'image/png'
      // ACL: 'public-read'
    }).promise();
    return logoKey;
  }

  /**
   * 
   * 
   * @param {any} event 
   * @returns 
   * 
   * @memberof RegistrationForm
   */
  onSubmit = async (event: Event) => {
    // Stop normal submit form action
    event.preventDefault();

    // Validate the whole form state, if we are in step 2 (last step)
    // then it will process required fields as well
    const errors = this.validateState(event, this.state.step === 2);

    // If no errors, then we switch the state to the second page
    if (errors.length === 0) {
      this.setState({
        step: this.state.step === 1 ? 2 : 2
      });
    } else {
      return;
    }

    // If we are still on the first page then don't try and submit the form
    if (this.state.step === 1) {
      return;
    }

    // Only form submission from here on
    this.setState({
      isSubmitting: true
    })
    //If image file, upload it to storage
    let logoFilename = await this.uploadLogo();

    /**
     * REGISTER USER
     */

    // Amazon Cognito needs specific array of SDK Attribute Objects.
    const attributeList = [];
    if (this.state.email) {
      attributeList.push(new CognitoUserAttribute({ Name: 'email', Value: this.state.email }));
    }
    if (this.state.fullName) {
      attributeList.push(new CognitoUserAttribute({ Name: 'name', Value: this.state.fullName }));
    }
    if (this.state.company) {
      attributeList.push(new CognitoUserAttribute({ Name: 'custom:company', Value: this.state.company }));
    }
    // if (this.state.phone) {
    //   const formattedPhone = `+1${this.state.phone.replace(/\D/g, '')}`;
    //   console.log(`formatted the phone: ${formattedPhone}`)
    //   attributeList.push(new CognitoUserAttribute({ Name: 'phone_number', Value: formattedPhone }));
    // }

    if (this.state.errors.length > 0) {
      return;
    }

    if (logoFilename) {
      logoFilename = new CognitoUserAttribute({ Name: 'picture', Value: `https://s3.amazonaws.com/jovi-avatarsresized/avatar-${logoFilename}` });
      attributeList.push(logoFilename);
    }

    userPool.signUp(this.state.email, this.state.password, attributeList, null, (err, result) => {
      if (err) {
        console.error('---User Signup ERROR---', err);
        this.setState({
          errors: [err.message],
          step: 1,
          isSubmitting: false
        })
        return;
      }
      this.setState({
        isSubmitting: false,
        step: 3
      });

      console.log('---User Signup Complete---', result);
    });
  }

  /**
   * 
   * 
   * @param {any} event 
   * @param {boolean} [submit=false] 
   * @returns 
   * 
   * @memberof RegistrationForm
   */
  validateState = (event: Event, submit: boolean = false) => {
    const errors = [];
    if (submit === true) {
      if (this.state.fullName.length === 0) {
        errors.push('Full Name is required');
        this.setState({
          step: 1
        });
        this.setMessage('Alright, let’s get started!')
      }
      if (this.state.email.length === 0) {
        errors.push('Email is required');
        this.setState({
          step: 1
        });
        this.setMessage('Alright, let’s get started!')
      }
      if (this.state.password.length === 0) {
        errors.push('Password is required');
        this.setState({
          step: 1
        });
        this.setMessage('Alright, let’s get started!')
      }
    }

    if (this.state.email.length > 0 && this.validateEmail()) {
      errors.push(this.validateEmail())
    }
    if (this.state.password.length > 0 && this.validatePassword()) {
      errors.push(this.validatePassword())
    }
    if (this.state.fullName.length > 0 && this.validateFullName()) {
      errors.push(this.validateFullName())
    }
    if (this.state.company.length > 0 && this.validateCompany()) {
      errors.push(this.validateCompany())
    }
    if (this.state.logo && this.validateLogo()) {
      errors.push(this.validateLogo())
    }

    this.setState({
      errors
    });
    return errors;
  }

  validateEmail = (): ?string => {
    // eslint-disable-next-line
    const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if (!emailRegex.test(this.state.email)) {
      return 'Invalid email address'
    }
    return null;
  }

validatePassword = (): ?string => {
  const strengthRegEx = new RegExp(/^(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{6,}/);
  if (!strengthRegEx.test(this.state.password)) {
    return 'Password be at least 6 characters with at least 1 number and 1 special character';
  }
  return null;
}

validateFullName = (): ?string => {
  return null;
}

validateLogo = (): ?string => {
  return null;
}

validateCompany = (): ?string => {
  return null;
}

// validatePhone() {
//   // remove anything that isnt a number
//   const normalizedPhone = this.state.phone.replace(/\D/g, '');
//   if (normalizedPhone.toString().length !== 10) {
//     return 'Phone must be of format (555) 555-5555'
//   }
//   return null;
// }

componentDidMount = (): void => {
  window.onpopstate = (event): void => {
    this.setState({
      step: this.state.step === 2 ? 1 : 1
    });
  }
}

render() {
  return (
    <div className='RegistrationForm'>
      <Link to='/'><img src={logo} alt='Jovi Inc.' className='RegistrationForm-logo' /></Link>
      <div className='RegistrationForm-message'>{this.state.message}</div>
      <FormErrors errors={this.state.errors} />
      <form id='Registration' onSubmit={this.onSubmit}>
        <Redirect path='/register' exact to='/register/step1' />
        <Route path='/register/step1' render={(props) =>
          (<div>
            <input className='step1' type='text' name='fullName' id='fullName' placeholder='Full Name' value={this.state.fullName} onBlur={this.validateState} onChange={this.onInputChanged} />
            <input className='step1' type='email' name='email' id='email' placeholder='Email' value={this.state.email} onBlur={this.validateState} onChange={this.onInputChanged} />
            <input className='step1' type='password' name='password' id='password' placeholder='Password' value={this.state.password} onBlur={this.validateState} onChange={this.onInputChanged} />
            <button>Sign In</button>
            {
              this.state.step === 2 && <Redirect to='/register/step2' push />
            }
          </div>)
        } />
        <Route path='/register/step2' render={(props) =>
          (<div>
            <AvatarInput setLogo={this.setLogo} />
            <input className='step2' type='text' name='company' id='company' placeholder='Company Name' value={this.state.company} onChange={this.onInputChanged} />
            {/*<input
                className='step2'
                type='tel'
                name='phone'
                id='phone'
                placeholder='Company Number'
                title='(555)555-5555'
                pattern='(\(?[0-9]{3}\)?\s?|[0-9]{3}-?)[0-9]{3}-?[0-9]{4}'
                value={this.state.phone}
                onChange={this.onInputChanged} />*/}
            <button type='submit'>
              {this.state.isSubmitting ?
                <img src={loading} alt='test' className='RegistrationForm-loading' />
                : 'Continue'}
            </button>
            {
              this.state.step === 1 && <Redirect to='/register/step1' />
            }
          </div>)
        } />

        <div className='RegistrationForm-footer'>
          {
            this.state.step === 1 ?
              <p>Whoops, I meant <a href="https://admin.jovi.rocks">log in</a></p>
              :
              <p>Skip</p>
          }
        </div>
      </form>
      {
        this.state.step === 3 && <Redirect to={{
          pathname: '/registrationComplete',
          state: {
            referrer: location.pathname
          },
          push: true
        }} />
      }
    </div >
  );
}
}



// WEBPACK FOOTER //
// ./src/components/RegistrationForm/RegistrationForm.jsx